export default ['api', function (api) {
    return {
        login: (payload) => {
            return api.post(`api/login`, payload)
                .then(response => response.data);
        },
        byReference: (payload) => {
            return api.post(`api/reservation/edit`, payload)
                .then(response => response.data);
        },
        register: (payload) => {
            return api.post(`api/account/create`, payload)
                .then(response => response.data);
        },
        setCustomerPassword: (payload) => {
            return api.post(`api/account/setPassword`, payload)
                .then(response => response.data);
        },
        setCorePassword: (payload) => {
            return api.post(`api/core/setPassword`, payload)
                .then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/services/authenticate.api.service.js